import { Skeleton as MuiSkeleton, SkeletonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { tokens } from '../../theme/styles/themeMui';

export type { SkeletonProps };

export const Skeleton: React.ComponentType<SkeletonProps> = styled(MuiSkeleton, {
  name: 'Skeleton',
  shouldForwardProp: (prop) => prop !== 'textSize',
})<SkeletonProps>(({ theme, variant, textSize }) => ({
  backgroundColor: theme.palette.colors.bg['neutral-secondary'],
  height: '2rem',
  ...(variant === 'text' && {
    borderRadius: '4px',
  }),
  ...(variant === 'text' &&
    textSize &&
    tokens.skeleton.sizeMap[textSize] && {
      height: `${tokens.skeleton.sizeMap[textSize]}px`,
    }),
}));
